(function ($, undefined) {
    'use strict';

    // ===== LOADER SPINNER STYLES =====
    var loaderStyles = `
        .ai-loader-spinner {
            display: inline-block;
            width: 16px;
            height: 16px;
            border: 3px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            border-top-color: #fff;
            animation: ai-spin 1s linear infinite;
            margin-right: 8px;
            vertical-align: middle;
        }

        @keyframes ai-spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }

        .ai-button-with-loader {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
        }

        /* ✅ Hide suggestions - feature disabled */
        #robotSuggestions,
        #drawerSuggestions {
            display: none !important;
        }

        /* ✅ Source Type Indicator Styles */
        .drawer-source-type-container {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 12px;
            padding: 8px;
            background-color: #f5f5f5;
            border-radius: 4px;
            border-left: 4px solid #2196F3;
        }

        .drawer-source-type-label {
            font-size: 12px;
            font-weight: 600;
            color: #666;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .drawer-source-type-badge {
            padding: 4px 12px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;
            white-space: nowrap;
        }

        .drawer-source-type-badge.load-data {
            background-color: #4CAF50;
            color: white;
        }

        .drawer-source-type-badge.research {
            background-color: #FF9800;
            color: white;
        }

        .drawer-source-type-badge.new-search {
            background-color: #2196F3;
            color: white;
        }

        .drawer-prompt-field-container {
            margin-bottom: 12px;
        }

        .drawer-prompt-label {
            display: block;
            font-size: 12px;
            font-weight: 600;
            color: #333;
            margin-bottom: 6px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .drawer-prompt-display {
            width: 100%;
            padding: 10px;
            border: 1px solid #ddd;
            border-radius: 4px;
            background-color: #fafafa;
            font-size: 13px;
            color: #333;
            font-family: monospace;
            max-height: 80px;
            overflow-y: auto;
            resize: none;
            cursor: text;
            white-space: pre-wrap;
            word-wrap: break-word;
        }

        /* ✅ Gemini-like Loader Styles */
        .drawer-loading-container {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 15px 10px;
            gap: 8px;
            flex-wrap: nowrap;
            margin: 10px 0;
            background-color: transparent;
            z-index: 1000;
            position: relative;
        }

        .drawer-loader-text {
            font-size: 13px;
            color: #666;
            font-weight: 500;
            white-space: nowrap;
            letter-spacing: 0.3px;
        }

        /* Gemini-style flowing dots loader */
        .gemini-loader {
            display: flex;
            gap: 6px;
            align-items: center;
        }

        .gemini-loader-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: linear-gradient(135deg, #4285F4, #EA4335, #FBBC04, #34A853);
            background-size: 300% 300%;
            animation: gemini-pulse 1.4s infinite;
        }

        .gemini-loader-dot:nth-child(2) {
            animation-delay: 0.2s;
        }

        .gemini-loader-dot:nth-child(3) {
            animation-delay: 0.4s;
        }

        @keyframes gemini-pulse {
            0% {
                opacity: 0.4;
                transform: scale(0.8);
            }
            50% {
                opacity: 1;
                transform: scale(1.2);
            }
            100% {
                opacity: 0.4;
                transform: scale(0.8);
            }
        }

        /* Alternative: Smooth flowing bar loader */
        .gemini-loader-bar {
            height: 3px;
            background: linear-gradient(90deg, #4285F4, #EA4335, #FBBC04, #34A853, #4285F4);
            background-size: 200% 100%;
            border-radius: 2px;
            animation: gemini-flow 2s infinite;
        }

        @keyframes gemini-flow {
            0% {
                background-position: 0% 0%;
            }
            50% {
                background-position: 100% 0%;
            }
            100% {
                background-position: 0% 0%;
            }
        }
    `;

    // Inject CSS into the document
    var styleSheet = document.createElement('style');
    styleSheet.textContent = loaderStyles;
    document.head.appendChild(styleSheet);

    var domain = window.location.hostname;

    var baseUrl = "";
    if (domain === "localhost") baseUrl = `http://localhost:9007`;
    else baseUrl = `/ai-service`;

    var init = function () {
        loadSearch();
    };

    function loadSearch() {
        var aiRobot = document.getElementById('aiRobot');
        var robotCard = document.getElementById('robotCard');
        var robotInput = document.getElementById('robotInput');
        var robotAsk = document.getElementById('robotAsk');
        var robotSuggestions = document.getElementById('robotSuggestions');

        var drawer = document.getElementById('drawer');
        var overlay = document.getElementById('overlay');
        var drawerClose = document.getElementById('drawerClose');
        var drawerInput = document.getElementById('drawerInput');
        var drawerAsk = document.getElementById('drawerAsk');
        var drawerSuggestions = document.getElementById('drawerSuggestions');
        var resultTable = document.getElementById('resultTable');
        var resizer = drawer ? drawer.querySelector('.resizer') : null;

        // ✅ Suggestions disabled - removed API calls

        var STORAGE_KEY = 'ai_robot_pos_v1';
        var KERA_HELP_SESSION_KEY = 'kera_insight_help_shown_v1';
        var ROBOT_MIN_VISIBLE = 40;
        var dragging = false, dragMoved = false, dragOffset = { x: 0, y: 0 };
        var dragStart = { x: 0, y: 0 };

        // ✅ Table download state (latest rendered results)
        var lastRows = [];
        var lastPayload = null;
        var lastSearchHistoryId = null; // ✅ Store search history ID from /api/kera/ask
        // ✅ Multi-turn chat memory: server-minted on first /ask, echoed back on every subsequent call
        //    so the LLM can resolve follow-ups like "yes", "the first one", or "now last year".
        var currentConversationId = null;
        // Tracks whether the drawer is showing a saved result vs an active search input.
        var drawerViewMode = null;
        var drawerDefaultPlaceholder = drawerInput ? (drawerInput.getAttribute("placeholder") || "") : "";

        // ✅ Chart state (for PDF)
        var lastCharts = [];
        var lastChartImages = []; // { title, dataUri, width, height }


        // ==========================================================
        // ✅ KERA HISTORY MODAL (UNIQUE IDs / NO COLLISION) - ES5
        // ==========================================================
        var keraHistoryOverlay = document.getElementById("keraHistoryOverlay");
        var keraHistoryCloseBtn = document.getElementById("keraHistoryCloseBtn");
        var keraHistoryOpenBtn = document.getElementById("robotHistory");
        var keraHistoryTbody = document.getElementById("keraHistoryTbody");
        var keraHistoryEmptyState = document.getElementById("keraHistoryEmptyState");
        var keraHistorySearchInput = document.getElementById("keraHistorySearchInput");
        var keraHistoryCountPill = document.getElementById("keraHistoryCountPill");

        // keep data in closure (avoid window.historyData)
        var keraHistoryData = [];

        // ✅ Kera help modal (once per session on first icon click)
        var keraHelpOverlay = document.getElementById('keraHelpOverlay');
        var keraHelpCloseBtn = document.getElementById('keraHelpCloseBtn');
        var keraHelpGotItBtn = document.getElementById('keraHelpGotItBtn');

        function keraHelpWasShown() {
            try {
                return sessionStorage.getItem(KERA_HELP_SESSION_KEY) === '1';
            } catch (e) {
                return false;
            }
        }

        function keraMarkHelpShown() {
            try {
                sessionStorage.setItem(KERA_HELP_SESSION_KEY, '1');
            } catch (e) { }
        }

        function keraOpenHelpModal() {
            if (!keraHelpOverlay) return;
            closeRobotCard();
            keraHelpOverlay.classList.add('open');
            keraHelpOverlay.setAttribute('aria-hidden', 'false');
        }

        function keraCloseHelpModal(openSearchAfter) {
            if (!keraHelpOverlay) return;
            keraHelpOverlay.classList.remove('open');
            keraHelpOverlay.setAttribute('aria-hidden', 'true');
            if (openSearchAfter) openRobotCard();
        }

        function keraMaybeShowHelpOnIconClick() {
            if (keraHelpWasShown()) return false;
            keraMarkHelpShown();
            keraOpenHelpModal();
            return true;
        }

        if (keraHelpCloseBtn) {
            keraHelpCloseBtn.addEventListener('click', function () {
                keraCloseHelpModal(false);
            });
        }
        if (keraHelpGotItBtn) {
            keraHelpGotItBtn.addEventListener('click', function () {
                keraCloseHelpModal(true);
            });
        }
        if (keraHelpOverlay) {
            keraHelpOverlay.addEventListener('click', function (e) {
                if (e.target === keraHelpOverlay) keraCloseHelpModal(false);
            });
        }

        function keraEscapeHtml(str) {
            str = (str === null || str === undefined) ? "" : String(str);
            return str
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }

        function keraRenderHistoryRows(rows) {
            if (!keraHistoryTbody) return;
            keraHistoryTbody.innerHTML = "";

            if (!rows || !rows.length) {
                if (keraHistoryEmptyState) keraHistoryEmptyState.style.display = "block";
                if (keraHistoryCountPill) keraHistoryCountPill.innerHTML = "<b>0</b> rows";
                return;
            }

            if (keraHistoryEmptyState) keraHistoryEmptyState.style.display = "none";
            if (keraHistoryCountPill) keraHistoryCountPill.innerHTML = "<b>" + rows.length + "</b> rows";

            var frag = document.createDocumentFragment();

            for (var i = 0; i < rows.length; i++) {
                var r = rows[i] || {};
                var tr = document.createElement("tr");

                tr.setAttribute("data-id", r.id || "");
                tr.setAttribute("data-prompt", r.prompt || "");

                // createdAt -> show as text (keep simple)
                var rawDt = r.createdAt || "";
                var dt = keraFormatCreatedAt(rawDt);
                tr.setAttribute("data-createdat", dt);

                // Create prompt cell
                var promptCell = document.createElement("td");
                promptCell.className = "col-prompt";
                promptCell.textContent = r.prompt || "";

                // Create date cell
                var dateCell = document.createElement("td");
                dateCell.className = "col-dt";
                dateCell.textContent = dt;

                // Create actions cell with Load Data and Research buttons
                var actionsCell = document.createElement("td");
                actionsCell.className = "col-actions";

                // Load Data button
                var loadBtn = document.createElement("button");
                loadBtn.type = "button";
                loadBtn.className = "kera-history-btn kera-history-btn-load";
                loadBtn.textContent = "Previous Result";
                loadBtn.title = "Load the saved data and charts from this search";
                loadBtn.setAttribute("data-id", r.id || "");
                loadBtn.setAttribute("data-prompt", r.prompt || "");
                loadBtn.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var historyId = this.getAttribute("data-id");
                    var prompt = this.getAttribute("data-prompt");
                    if (!historyId) return;

                    // ✅ Store the search history ID
                    lastSearchHistoryId = historyId;
                    console.log("✅ Load Data clicked - History ID set:", lastSearchHistoryId);

                    keraCloseHistoryModal();
                    appendTable(null, "Loading saved result...", null);
                    clearCharts();
                    openDrawer();
                    // ✅ Display source type and prompt in drawer
                    displayDrawerSourceInfo('loadData', prompt);
                    keraLoadHistoryResult(historyId, userId);
                });

                // Research button
                var researchBtn = document.createElement("button");
                researchBtn.type = "button";
                researchBtn.className = "kera-history-btn kera-history-btn-research";
                researchBtn.textContent = "New Search";
                researchBtn.title = "Re-run the search with the original question to get fresh results";
                researchBtn.setAttribute("data-prompt", r.prompt || "");
                researchBtn.setAttribute("data-id", r.id || "");
                researchBtn.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var prompt = this.getAttribute("data-prompt");
                    var historyId = this.getAttribute("data-id");
                    if (!prompt) return;

                    // ✅ Store the search history ID
                    lastSearchHistoryId = historyId;
                    console.log("✅ Research clicked - History ID set:", lastSearchHistoryId);

                    keraCloseHistoryModal();
                    drawerInput.value = prompt;
                    updateDrawerInputState();
                    openDrawer();
                    // ✅ Display source type and prompt in drawer
                    displayDrawerSourceInfo('research', prompt);
                    setTimeout(function () { drawerAskHandler(); }, 120);
                });

                actionsCell.appendChild(researchBtn);
                actionsCell.appendChild(loadBtn);

                tr.appendChild(promptCell);
                tr.appendChild(dateCell);
                tr.appendChild(actionsCell);

                frag.appendChild(tr);
            }

            keraHistoryTbody.appendChild(frag);
        }

        function keraOrdinal(n) {
            n = Number(n) || 0;
            const mod100 = n % 100;
            if (mod100 >= 11 && mod100 <= 13) return n + "th";
            switch (n % 10) {
                case 1: return n + "st";
                case 2: return n + "nd";
                case 3: return n + "rd";
                default: return n + "th";
            }
        }

        function keraFormatCreatedAt(dtStr) {
            if (!dtStr) return "";

            // Try parsing. Works for ISO strings like "2026-01-02T14:05:00Z" or with offset.
            const d = new Date(dtStr);
            if (isNaN(d.getTime())) return String(dtStr); // fallback: show raw if unparseable

            const month = new Intl.DateTimeFormat(undefined, { month: "short" }).format(d);
            const year = d.getFullYear();
            const day = keraOrdinal(d.getDate());

            const time = new Intl.DateTimeFormat(undefined, {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false
            }).format(d);

            // Example: "Jan 2nd 2025 14:05"
            return `${month} ${day} ${year} ${time}`;
        }


        function keraOpenHistoryModal() {
            if (!keraHistoryOverlay) return;
            keraHistoryOverlay.classList.add("open");
            keraHistoryOverlay.setAttribute("aria-hidden", "false");
            if (keraHistorySearchInput) keraHistorySearchInput.value = "";
            keraRenderHistoryRows(keraHistoryData);
            setTimeout(function () {
                if (keraHistorySearchInput) keraHistorySearchInput.focus();
            }, 50);
        }

        function keraCloseHistoryModal() {
            if (!keraHistoryOverlay) return;
            keraHistoryOverlay.classList.remove("open");
            keraHistoryOverlay.setAttribute("aria-hidden", "true");
        }

        // ✅ Fetch history list (FAST: id, prompt, createdAt only)
        function loadHistory(personId, cb) {
            $.ajax({
                url: baseUrl + "/api/kera/history",
                method: "GET",
                dataType: "json",
                data: { personId: personId, limit: 50 },
                success: function (res) {
                    var arr = (res && res.history) ? res.history : [];
                    var out = [];
                    for (var i = 0; i < arr.length; i++) {
                        var it = arr[i] || {};
                        out.push({
                            id: it.id || it._id || it.Id || "",
                            prompt: it.prompt || "",
                            createdAt: it.createdAt || it.created_at || ""
                        });
                    }
                    cb && cb(out);
                },
                error: function () {
                    cb && cb([]);
                }
            });
        }

        // ✅ Fetch one history record (FULL payload: rows + charts etc)
        function loadHistoryDetail(personId, historyId, cb) {
            $.ajax({
                url: baseUrl + "/api/kera/history/" + encodeURIComponent(historyId),
                method: "GET",
                dataType: "json",
                data: { personId: personId },
                success: function (res) {
                    cb && cb(res || null);
                },
                error: function () {
                    cb && cb(null);
                }
            });
        }

        // ✅ Load history result and display it in the table
        function keraLoadHistoryResult(historyId, personId) {
            if (!historyId) {
                console.error("History ID is missing");
                return;
            }

            // Handle personId - could be element or string value
            if (personId) {
                // If it's an element, extract the value
                if (personId.nodeType || personId.tagName) {
                    personId = personId.value;
                }
            }

            // If personId is still not available, try to get it from the DOM
            if (!personId) {
                const userIdElement = document.getElementById("userId");
                personId = userIdElement ? userIdElement.value : null;
            }

            if (!personId) {
                alert("User ID not found.");
                return;
            }

            console.log("✅ Loading history. ID:", historyId, "PersonID:", personId);

            loadHistoryDetail(personId, historyId, function (data) {
                if (!data) {
                    appendTable(null, "Failed to load history result.", null);
                    return;
                }

                // ✅ Always show the prompt stored with this history record, not the last typed query.
                var savedPrompt = data.prompt || "";
                displayDrawerSourceInfo('loadData', savedPrompt);

                // ✅ Handle nested structure: data.dataset.rows or data.rows
                var rows = [];
                if (data && data.dataset && data.dataset.rows && data.dataset.rows.length) {
                    rows = data.dataset.rows;
                } else if (data && data.rows && data.rows.length) {
                    rows = data.rows;
                }

                appendTable(rows, null, data.dataset || null);
                renderChartsFromResponse(data.dataset || null);

                // ✅ Ensure the ID is set for PDF download
                lastSearchHistoryId = historyId;
                console.log("✅ History loaded - ID set:", lastSearchHistoryId);

                // ✅ Enable PDF button since we have a history ID
                const btnPdf = document.getElementById("ai-download-pdf");
                if (btnPdf && rows && rows.length) {
                    btnPdf.disabled = false;
                    btnPdf.style.opacity = "1";
                }
            });
        }



        // ✅ Click history row => fill robot input + run
        function setRobotValue(text) {
            if (!robotInput) return;
            // contenteditable?
            if (robotInput.getAttribute && robotInput.getAttribute("contenteditable") === "true") {
                robotInput.innerText = text || "";
            } else {
                robotInput.value = text || "";
            }
        }

        function getRobotValue() {
            if (!robotInput) return "";
            if (robotInput.getAttribute && robotInput.getAttribute("contenteditable") === "true") {
                return $.trim(robotInput.innerText || "");
            }
            return $.trim(robotInput.value || "");
        }

        function updateRobotInputState() {
            if (!robotAsk) return;
            var v = getRobotValue();
            robotAsk.disabled = v.length === 0;
            // ✅ Suggestions disabled
        }

        if (keraHistoryOpenBtn) {
            $(document).on("click", ".btn-history", function () {
                var userIdElement = document.getElementById("userId");
                var userId = userIdElement ? $.trim(userIdElement.value) : null;

                keraHistoryData = [];

                if (!userId) {
                    keraOpenHistoryModal();
                    return;
                }

                loadHistory(userId, function (rows) {
                    keraHistoryData = rows || [];
                    keraOpenHistoryModal();
                });
            });
        }

        // ✅ Suggestions disabled - removed focus/blur listeners

        if (keraHistoryCloseBtn) keraHistoryCloseBtn.addEventListener("click", keraCloseHistoryModal);
        if (keraHistoryOverlay) {
            keraHistoryOverlay.addEventListener("click", function (e) {
                if (e.target === keraHistoryOverlay) keraCloseHistoryModal();
            });
        }

        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape") {
                // close both robot card & drawer (your existing behavior)
                closeRobotCard();
                closeDrawer();

                // close history modal if open
                if (keraHistoryOverlay && keraHistoryOverlay.classList.contains("open")) {
                    keraCloseHistoryModal();
                }

                // close help modal if open
                if (keraHelpOverlay && keraHelpOverlay.classList.contains("open")) {
                    keraCloseHelpModal(false);
                }
            }
        });

        if (keraHistorySearchInput) {
            keraHistorySearchInput.addEventListener("input", function () {
                var q = $.trim(keraHistorySearchInput.value || "").toLowerCase();
                if (!q) return keraRenderHistoryRows(keraHistoryData);

                var filtered = [];
                for (var i = 0; i < keraHistoryData.length; i++) {
                    var p = String(keraHistoryData[i].prompt || "").toLowerCase();
                    if (p.indexOf(q) !== -1) filtered.push(keraHistoryData[i]);
                }
                keraRenderHistoryRows(filtered);
            });
        }

        // ✅ Table rows now have Load Data and Research buttons instead of being clickable

        // ======================================
        // ✅ Export styling from table header
        // ======================================
        function getHeaderTheme() {
            try {
                if (!resultTable) return null;
                const th = resultTable.querySelector("thead th");
                if (!th) return null;
                const cs = window.getComputedStyle(th);
                return {
                    bg: cs.getPropertyValue("background-color") || "#54834D",
                    fg: cs.getPropertyValue("color") || "#ffffff",
                    border: cs.getPropertyValue("border-color") || "#d1d5db"
                };
            } catch (e) {
                return null;
            }
        }

        // Restore position
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);
            if (raw && aiRobot) {
                const p = JSON.parse(raw);
                const vw = window.innerWidth, vh = window.innerHeight;
                aiRobot.style.left = Math.min(Math.max(0, p.left), vw - ROBOT_MIN_VISIBLE) + 'px';
                aiRobot.style.top = Math.min(Math.max(0, p.top), vh - ROBOT_MIN_VISIBLE) + 'px';
                aiRobot.style.right = 'auto';
            }
        } catch (e) { }

        function savePosition() {
            if (!aiRobot) return;
            const rect = aiRobot.getBoundingClientRect();
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ left: rect.left, top: rect.top }));
        }

        if (aiRobot) {
            aiRobot.addEventListener('dblclick', openDrawer);

            aiRobot.addEventListener('pointerdown', function (e) {
                e.preventDefault();
                dragging = true;
                dragMoved = false;
                dragStart.x = e.clientX;
                dragStart.y = e.clientY;
                aiRobot.setPointerCapture(e.pointerId);
                var rect = aiRobot.getBoundingClientRect();
                dragOffset.x = e.clientX - rect.left;
                dragOffset.y = e.clientY - rect.top;
                aiRobot.style.transition = 'none';
            });

            window.addEventListener('pointermove', function (e) {
                if (!dragging) return;
                if (Math.abs(e.clientX - dragStart.x) > 5 || Math.abs(e.clientY - dragStart.y) > 5) {
                    dragMoved = true;
                }
                e.preventDefault();
                var vw = window.innerWidth, vh = window.innerHeight;
                var left = e.clientX - dragOffset.x, top = e.clientY - dragOffset.y;
                left = Math.min(Math.max(4, left), vw - ROBOT_MIN_VISIBLE);
                top = Math.min(Math.max(4, top), vh - ROBOT_MIN_VISIBLE);
                aiRobot.style.left = left + 'px';
                aiRobot.style.top = top + 'px';
                aiRobot.style.right = 'auto';
            });

            aiRobot.addEventListener('pointerup', function (e) {
                if (!dragging) return;
                dragging = false;
                aiRobot.releasePointerCapture(e.pointerId);
                aiRobot.style.transition = '';
                savePosition();
            });

            aiRobot.addEventListener('keydown', function (ev) {
                if (ev.key === 'Enter' || ev.key === ' ') {
                    ev.preventDefault();
                    toggleRobotCard();
                }
            });

            aiRobot.addEventListener('click', function () {
                if (dragMoved) return;
                if (keraMaybeShowHelpOnIconClick()) return;
                toggleRobotCard();
            });
        }

        function computeCardPlacement() {
            if (!aiRobot) return { openBelow: true, left: 0, top: 0, rect: { left: 0, top: 0, bottom: 0, width: 60, height: 60 } };
            var robotRect = aiRobot.getBoundingClientRect();
            const cardHeightEstimate = 220;
            const margin = 8;
            const spaceBelow = window.innerHeight - (robotRect.top + robotRect.height);
            const spaceAbove = robotRect.top;
            const openBelow = spaceBelow >= (cardHeightEstimate + margin) || spaceBelow >= spaceAbove;
            return { openBelow, left: robotRect.left, top: robotRect.top, rect: robotRect };
        }

        function openRobotCard() {
            if (!robotCard || !robotInput || !aiRobot) return;

            const placement = computeCardPlacement();
            robotCard.classList.add('open');
            robotCard.setAttribute('aria-hidden', 'false');
            const robotRect = placement.rect;

            const cardW = Math.min(520, Math.max(480, robotRect.width * 6));
            robotCard.style.width = cardW + 'px';

            let left = robotRect.left + (robotRect.width / 2) - (cardW / 2);
            left = Math.max(8, Math.min(left, window.innerWidth - cardW - 8));

            if (placement.openBelow) {
                robotCard.style.top = (robotRect.bottom + 10) + 'px';
                robotCard.style.left = left + 'px';
                robotCard.style.transform = 'translateY(-4px)';
            } else {
                const h = robotCard.offsetHeight || 220;
                robotCard.style.left = left + 'px';
                robotCard.style.top = Math.max(6, robotRect.top - (h + 10)) + 'px';
                robotCard.style.transform = 'translateY(4px)';
            }

            setTimeout(function () {
                robotCard.style.transform = 'translateY(0)';
                robotInput.focus();
                robotInput.select();
            }, 14);
        }

        function closeRobotCard() {
            if (!robotCard) return;
            robotCard.classList.remove('open');
            robotCard.setAttribute('aria-hidden', 'true');
        }

        function toggleRobotCard() {
            if (!robotCard) return;
            if (robotCard.classList.contains('open')) closeRobotCard();
            else openRobotCard();
        }

        document.addEventListener('mousedown', function (ev) {
            if (!robotCard || !aiRobot) return;
            if (!robotCard.contains(ev.target) && !aiRobot.contains(ev.target)) closeRobotCard();
        });

        document.addEventListener('keydown', function (ev) {
            if (ev.key === 'Escape') {
                closeRobotCard();
                closeDrawer();
                if (keraHelpOverlay && keraHelpOverlay.classList.contains('open')) {
                    keraCloseHelpModal(false);
                }
            }
        });

        function updateRobotInputState() {
            if (!robotAsk || !robotInput) return;
            robotAsk.disabled = robotInput.value.trim().length === 0;
            // ✅ Suggestions disabled
        }

        if (robotInput) robotInput.addEventListener('input', updateRobotInputState);

        if (robotInput) {
            robotInput.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    var q = robotInput.value.trim();
                    if (q && robotAsk) {
                        robotAsk.click();
                    }
                }
            });
        }

        if (robotAsk) {
            robotAsk.addEventListener('click', function () {
                var q = robotInput.value.trim();
                if (!q) return;
                openDrawerWithQuery(q);
            });
        }

        // ✅ Suggestions click handler disabled
        if (robotSuggestions) {
            // Click handler removed - suggestions disabled
        }

        if (robotInput) {
            robotInput.addEventListener('keydown', function (ev) {
                if (ev.key === 'Enter') {
                    var q = robotInput.value.trim();
                    if (!q) return;
                    openDrawerWithQuery(q);
                }
            });
        }

        function setDrawerSearchInputVisible(visible) {
            var searchWrap = drawer ? drawer.querySelector('.search-wrap') : null;
            if (searchWrap) searchWrap.style.display = visible ? '' : 'none';
        }

        function restoreDrawerSearchInput() {
            setDrawerSearchInputVisible(true);
            if (drawerInput) {
                drawerInput.removeAttribute('readonly');
                drawerInput.setAttribute('placeholder', drawerDefaultPlaceholder || 'Type or click a suggestion…');
            }
            updateDrawerInputState();
        }

        // ✅ Helper function to display source type and prompt in drawer
        function displayDrawerSourceInfo(sourceType, prompt) {
            if (!drawer) return;

            drawerViewMode = sourceType || null;

            // Create or update source type indicator container
            var sourceContainer = drawer.querySelector('.drawer-source-type-container');
            if (!sourceContainer) {
                sourceContainer = document.createElement('div');
                sourceContainer.className = 'drawer-source-type-container';
                var drawerHeader = drawer.querySelector('[id="drawer"] > :first-child') || drawer.firstChild;
                if (drawerHeader) {
                    drawerHeader.parentNode.insertBefore(sourceContainer, drawerHeader);
                } else {
                    drawer.insertBefore(sourceContainer, drawer.firstChild);
                }
            }
            sourceContainer.style.display = 'flex';

            // Update badge with source type
            var badge = sourceContainer.querySelector('.drawer-source-type-badge');
            if (!badge) {
                badge = document.createElement('span');
                badge.className = 'drawer-source-type-badge';
                sourceContainer.innerHTML = '<span class="drawer-source-type-label">Source:</span>';
                sourceContainer.appendChild(badge);
            }

            var badgeText, badgeClass;
            if (sourceType === 'loadData') {
                badgeText = 'Previous Result (Saved)';
                badgeClass = 'load-data';
            } else if (sourceType === 'research') {
                badgeText = 'Research (New Search)';
                badgeClass = 'research';
            } else if (sourceType === 'newSearch') {
                badgeText = 'New Prompt Search';
                badgeClass = 'new-search';
            } else {
                badgeText = 'Unknown Source';
                badgeClass = '';
            }

            badge.textContent = badgeText;
            badge.className = 'drawer-source-type-badge ' + badgeClass;

            // Create or update prompt display field
            var promptContainer = drawer.querySelector('.drawer-prompt-field-container');
            if (!promptContainer) {
                promptContainer = document.createElement('div');
                promptContainer.className = 'drawer-prompt-field-container';
                sourceContainer.parentNode.insertBefore(promptContainer, sourceContainer.nextSibling);
            }

            if (sourceType === 'loadData') {
                // Viewing a saved result: show the historical prompt only, not the last typed query.
                setDrawerSearchInputVisible(false);
                if (drawerInput) drawerInput.value = '';
                promptContainer.style.display = 'block';
                promptContainer.innerHTML = '<label class="drawer-prompt-label">Prompt for this result:</label>' +
                    '<div class="drawer-prompt-display">' +
                    (prompt || '<em>No prompt selected</em>') +
                    '</div>';
                updateDrawerInputState();
            } else if (sourceType === 'newSearch') {
                restoreDrawerSearchInput();
                promptContainer.style.display = 'none';
            } else {
                restoreDrawerSearchInput();
                promptContainer.style.display = 'block';
                promptContainer.innerHTML = '<label class="drawer-prompt-label">Selected Prompt:</label>' +
                    '<div class="drawer-prompt-display">' +
                    (prompt || '<em>No prompt selected</em>') +
                    '</div>';
            }
        }

        // ✅ Clear source info from drawer
        function clearDrawerSourceInfo() {
            if (!drawer) return;
            var sourceContainer = drawer.querySelector('.drawer-source-type-container');
            var promptContainer = drawer.querySelector('.drawer-prompt-field-container');
            if (sourceContainer) sourceContainer.style.display = 'none';
            if (promptContainer) promptContainer.style.display = 'none';
        }

        // ✅ Show Gemini-like loader in drawer
        function showDrawerLoader() {
            if (!drawer) return;

            // Keep the source info ("New Prompt Search") visible.
            var sourceContainer = drawer.querySelector('.drawer-source-type-container');
            if (sourceContainer) {
                sourceContainer.style.display = 'flex';
            }

            // ✅ ChatGPT-style behaviour: clear the previous result so the working
            //    indicator REPLACES the old graph/table instead of sitting above it.
            try { clearCharts(); } catch (e) { /* noop */ }
            if (resultTable) resultTable.innerHTML = "";
            try { showDownloadBar(0); } catch (e) { /* noop */ }
            var oldDebug = document.getElementById("ai-debug-box");
            if (oldDebug) oldDebug.remove();

            // Create or get the loader container
            var loaderContainer = drawer.querySelector('.drawer-loading-container');
            if (!loaderContainer) {
                loaderContainer = document.createElement('div');
                loaderContainer.className = 'drawer-loading-container';

                // Create text
                var loaderText = document.createElement('span');
                loaderText.className = 'drawer-loader-text';
                loaderText.textContent = 'Working...';
                loaderContainer.appendChild(loaderText);

                // Create dots loader (Gemini style)
                var dotsLoader = document.createElement('div');
                dotsLoader.className = 'gemini-loader';
                for (var i = 0; i < 3; i++) {
                    var dot = document.createElement('div');
                    dot.className = 'gemini-loader-dot';
                    dotsLoader.appendChild(dot);
                }
                loaderContainer.appendChild(dotsLoader);
            }

            // ✅ Position the loader INSIDE the results area (where the graph/table
            //    render), so "Working..." shows in place of the previous result.
            loaderContainer.classList.add('in-results');
            if (resultTable && resultTable.parentNode) {
                resultTable.parentNode.insertBefore(loaderContainer, resultTable);
            } else if (sourceContainer && sourceContainer.parentNode) {
                loaderContainer.classList.remove('in-results');
                sourceContainer.parentNode.insertBefore(loaderContainer, sourceContainer.nextSibling);
            } else {
                loaderContainer.classList.remove('in-results');
                drawer.insertBefore(loaderContainer, drawer.firstChild);
            }

            // Ensure loader is visible
            loaderContainer.style.display = 'flex';
            loaderContainer.style.visibility = 'visible';
            loaderContainer.style.opacity = '1';
        }

        // ✅ Hide Gemini-like loader in drawer
        function hideDrawerLoader() {
            if (!drawer) return;
            var loaderContainer = drawer.querySelector('.drawer-loading-container');
            if (loaderContainer) {
                loaderContainer.style.display = 'none';
                loaderContainer.style.visibility = 'hidden';
                loaderContainer.style.opacity = '0';
            }
        }

        function openDrawer() {
            if (!drawer || !overlay) return;
            drawer.classList.add('open');
            overlay.classList.add('show');
            drawer.setAttribute('aria-hidden', 'false');
            overlay.setAttribute('aria-hidden', 'false');
            setTimeout(function () { drawerInput && drawerInput.focus(); }, 200);
        }

        function closeDrawer() {
            if (!drawer || !overlay) return;
            drawer.classList.remove('open');
            overlay.classList.remove('show');
            drawer.setAttribute('aria-hidden', 'true');
            overlay.setAttribute('aria-hidden', 'true');
        }

        if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
        if (overlay) overlay.addEventListener('click', closeDrawer);

        function updateDrawerInputState() {
            if (!drawerAsk || !drawerInput) return;
            // ✅ While a search is in flight, the button is acting as a Stop
            //    button — keep it enabled regardless of input contents.
            if (drawerAsk.dataset.aiMode === 'stop') {
                drawerAsk.disabled = false;
                return;
            }
            drawerAsk.disabled = drawerInput.value.trim().length === 0;
            // ✅ Suggestions disabled
        }

        if (drawerInput) drawerInput.addEventListener('input', updateDrawerInputState);

        if (drawerInput) {
            drawerInput.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    var q = drawerInput.value.trim();
                    if (q && drawerAsk) {
                        drawerAsk.click();
                    }
                }
            });
        }

        // ✅ Suggestions click handler disabled
        if (drawerSuggestions) {
            // Click handler removed - suggestions disabled
        }

        // ============================================
        // ✅ GOOGLE CHARTS (NO HTML CHANGES REQUIRED)
        // ============================================

        function ensureChartsWrap() {
            if (!resultTable || !resultTable.parentNode) return null;

            let wrap = document.getElementById("ai-charts-wrap");
            if (wrap) return wrap;

            wrap = document.createElement("div");
            wrap.id = "ai-charts-wrap";
            wrap.style.display = "none";
            wrap.style.margin = "10px 0";
            wrap.style.padding = "0";
            wrap.style.width = "100%";
            wrap.style.boxSizing = "border-box";

            resultTable.parentNode.insertBefore(wrap, resultTable);
            return wrap;
        }

        let googleChartsReady = false;
        let googleChartsLoading = false;
        let googleChartsLoaderInjected = false;

        function ensureGoogleChartsReady(cb) {
            if ((!window.google || !window.google.charts) && !googleChartsLoaderInjected) {
                googleChartsLoaderInjected = true;

                const s = document.createElement("script");
                s.src = "https://www.gstatic.com/charts/loader.js";
                s.async = true;
                s.onload = function () { ensureGoogleChartsReady(cb); };
                s.onerror = function () {
                    console.warn("Failed to load Google Charts loader.js");
                    cb && cb(false);
                };
                document.head.appendChild(s);
                return;
            }

            if (!window.google || !window.google.charts) {
                cb && cb(false);
                return;
            }

            if (googleChartsReady) {
                cb && cb(true);
                return;
            }

            if (!googleChartsLoading) {
                googleChartsLoading = true;
                google.charts.load("current", { packages: ["corechart", "table"] });
                google.charts.setOnLoadCallback(function () {
                    googleChartsReady = true;
                    googleChartsLoading = false;
                    cb && cb(true);
                });
            } else {
                const t = setInterval(function () {
                    if (googleChartsReady) {
                        clearInterval(t);
                        cb && cb(true);
                    }
                }, 60);
            }
        }

        function mergeOptions(base, override) {
            const out = Object.assign({}, base || {}, override || {});
            out.chartArea = Object.assign({}, (base && base.chartArea) || {}, (override && override.chartArea) || {});
            out.hAxis = Object.assign({}, (base && base.hAxis) || {}, (override && override.hAxis) || {});
            out.vAxis = Object.assign({}, (base && base.vAxis) || {}, (override && override.vAxis) || {});
            out.tooltip = Object.assign({}, (base && base.tooltip) || {}, (override && override.tooltip) || {});
            out.legend = Object.assign({}, (base && base.legend) || {}, (override && override.legend) || {});
            return out;
        }

        function defaultChartOptionsFor(chartType) {
            const base = {
                chartArea: { left: 60, right: 20, top: 30, bottom: 110 },
                hAxis: {
                    slantedText: true,
                    slantedTextAngle: 45,
                    textStyle: { fontSize: 10 },
                    format: "MMM d"
                },
                vAxis: { textStyle: { fontSize: 10 } },
                tooltip: { trigger: "focus", isHtml: true },
                focusTarget: "category",
                legend: { position: "bottom" }
            };

            if (chartType === "BarChart") {
                base.chartArea = { left: 140, right: 20, top: 30, bottom: 50 };
            }
            return base;
        }

        function buildDataTableWithOptionalTooltip(c) {
            const dt = new google.visualization.DataTable();

            const cols = Array.isArray(c.columns) ? c.columns : [];
            const rows = Array.isArray(c.rows) ? c.rows : [];

            // Add columns (ignore any tooltip role coming from backend; we will do our own tooltip)
            cols.forEach(function (col) {
                if (col && col.role) {
                    // skip tooltip columns from backend to avoid default tooltip duplication
                    if (col.role === "tooltip") return;

                    dt.addColumn({
                        type: col.type || "string",
                        label: col.label || "",
                        role: col.role,
                        p: col.p || undefined
                    });
                } else {
                    dt.addColumn(col.type || "string", col.label || "");
                }
            });

            // Add rows but also strip tooltip cells if backend included them
            const cleanedRows = rows.map(function (r) {
                const rr = Array.isArray(r) ? r.slice() : [];
                // keep only as many values as we have dt columns
                return rr.slice(0, dt.getNumberOfColumns());
            });

            dt.addRows(cleanedRows);
            return dt;
        }

        function attachCustomTooltip(chart, chartDiv, dt, cols, firstType) {
            if (!chart || !chartDiv || !dt) return;

            // create tooltip div once per chart container
            let tip = chartDiv.parentNode.querySelector(".ai-custom-tip");
            if (!tip) {
                tip = document.createElement("div");
                tip.className = "ai-custom-tip";
                tip.style.position = "absolute";
                tip.style.display = "none";
                tip.style.pointerEvents = "none";
                tip.style.background = "#fff";
                tip.style.border = "1px solid rgba(0,0,0,0.2)";
                tip.style.borderRadius = "4px";
                tip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                tip.style.padding = "10px 12px";
                tip.style.fontFamily = "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif";
                tip.style.fontSize = "13px";
                tip.style.color = "#111827";
                tip.style.zIndex = "999999";

                // chartDiv is inside a card; make sure card is positioned
                const card = chartDiv.parentNode;
                if (card && window.getComputedStyle(card).position === "static") {
                    card.style.position = "relative";
                }
                card.appendChild(tip);
            }

            const dateFmt = new google.visualization.DateFormat({ pattern: "MMM d, yyyy hh:mm a" });

            function formatX(x) {
                if (x === null || x === undefined) return "";
                if (firstType === "date" || firstType === "datetime") {
                    const d = x instanceof Date ? x : new Date(x);
                    if (d && !isNaN(d.getTime())) {
                        const tmp = new google.visualization.DataTable();
                        tmp.addColumn("date", "d");
                        tmp.addRow([d]);
                        dateFmt.format(tmp, 0);
                        return tmp.getValue(0, 0);
                    }
                }
                return String(x);
            }

            function fmtVal(v) {
                if (v === null || v === undefined) return "";
                if (typeof v === "number") return Number.isInteger(v) ? String(v) : String(Math.round(v * 100) / 100);
                const s = String(v).trim();
                return s;
            }

            // uses chart layout interface for pixel coordinates
            function positionTip(row, col) {
                const cli = chart.getChartLayoutInterface && chart.getChartLayoutInterface();
                if (!cli) return;

                const x = cli.getXLocation(dt.getValue(row, 0));
                const y = cli.getYLocation(dt.getValue(row, col));

                // chartArea box (relative to chartDiv)
                const ca = cli.getChartAreaBoundingBox();
                if (!ca) return;

                // place tooltip near point, clamp into chart area
                const left = Math.max(8, Math.min(ca.left + x + 12, ca.left + ca.width - 220));
                const top = Math.max(8, Math.min(ca.top + y - 10, ca.top + ca.height - 80));

                tip.style.left = left + "px";
                tip.style.top = top + "px";
            }

            google.visualization.events.addListener(chart, "onmouseover", function (e) {
                try {
                    if (!e || e.row == null) return;

                    // pick first series column (usually Count). In DataTable series start at 1
                    const seriesCol = (e.column != null && e.column > 0) ? e.column : 1;
                    const label = (cols[seriesCol] && cols[seriesCol].label) ? cols[seriesCol].label : "Count";

                    const xLabel = formatX(dt.getValue(e.row, 0));
                    const val = fmtVal(dt.getValue(e.row, seriesCol));

                    tip.innerHTML =
                        '<div style="font-weight:800; font-size:16px; margin-bottom:8px;">' + xLabel + '</div>' +
                        '<div style="display:flex; gap:10px; align-items:center;">' +
                        '<div style="width:8px; height:8px; background:#1a73e8; border-radius:2px;"></div>' +
                        '<div style="font-weight:700;">' + label + ':</div>' +
                        '<div style="margin-left:auto; font-weight:800;">' + val + '</div>' +
                        '</div>';

                    tip.style.display = "block";
                    positionTip(e.row, seriesCol);
                } catch (err) {
                    // no-op
                }
            });

            google.visualization.events.addListener(chart, "onmouseout", function () {
                tip.style.display = "none";
            });
        }


        function getResultTableRect() {
            if (!resultTable) return null;
            const r = resultTable.getBoundingClientRect();
            if (!r || r.width <= 0) return null;
            return r;
        }

        function fitCardToTable(cardEl, wrapEl) {
            const tableRect = getResultTableRect();
            if (!tableRect || !cardEl || !wrapEl) return null;

            wrapEl.style.width = "100%";
            wrapEl.style.boxSizing = "border-box";

            const wrapRect = wrapEl.getBoundingClientRect();
            const leftOffset = Math.max(0, Math.round(tableRect.left - wrapRect.left));
            const w = Math.round(tableRect.width);

            cardEl.style.width = w + "px";
            cardEl.style.maxWidth = w + "px";
            cardEl.style.boxSizing = "border-box";
            cardEl.style.marginLeft = leftOffset + "px";
            cardEl.style.marginRight = "0";

            return w;
        }

        function renderChartsFromResponse(payload) {
            const wrap = ensureChartsWrap();
            if (!wrap) return;

            wrap.innerHTML = "";
            wrap.style.display = "none";

            const charts = payload && Array.isArray(payload.charts) ? payload.charts : [];
            lastCharts = charts;
            lastChartImages = [];

            const btnPdf = document.getElementById("ai-download-pdf");
            if (btnPdf) { btnPdf.disabled = true; btnPdf.style.opacity = "0.6"; }

            if (!charts.length) return;

            ensureGoogleChartsReady(function (ok) {
                if (!ok) return;

                wrap.style.display = "block";

                charts.forEach(function (c, idx) {
                    const id = c.id || ("chart_" + idx);

                    const card = document.createElement("div");
                    card.style.border = "1px solid #e5e7eb";
                    card.style.borderRadius = "12px";
                    card.style.background = "#fff";
                    card.style.boxShadow = "0 2px 10px rgba(0,0,0,0.04)";
                    card.style.padding = "10px 12px";
                    card.style.marginBottom = "10px";
                    card.style.boxSizing = "border-box";

                    const titleText = c.title || "Chart";

                    const title = document.createElement("div");
                    title.innerText = titleText;
                    title.style.fontWeight = "800";
                    title.style.fontSize = "13px";
                    title.style.marginBottom = "4px";
                    title.style.color = "#111827";
                    card.appendChild(title);

                    // Add description/subtitle if available
                    if (c.description || c.subtitle) {
                        const desc = document.createElement("div");
                        desc.innerText = c.description || c.subtitle;
                        desc.style.fontSize = "12px";
                        desc.style.color = "#6b7280";
                        desc.style.marginBottom = "8px";
                        desc.style.lineHeight = "1.4";
                        card.appendChild(desc);
                    }

                    const chartDiv = document.createElement("div");
                    chartDiv.id = id;
                    chartDiv.style.width = "100%";
                    chartDiv.style.boxSizing = "border-box";

                    const rowCount = Array.isArray(c.rows) ? c.rows.length : 0;
                    const baseH = (c.height || 260);
                    const extra = Math.min(260, Math.max(0, Math.floor(rowCount / 5) * 18));
                    const finalH = Math.min(580, baseH + extra);
                    chartDiv.style.height = finalH + "px";

                    card.appendChild(chartDiv);

                    // Add legend/info box showing what columns represent
                    const cols = Array.isArray(c.columns) ? c.columns : [];
                    if (cols.length > 1) {
                        const infoBox = document.createElement("div");
                        infoBox.style.marginTop = "8px";
                        infoBox.style.padding = "8px 10px";
                        infoBox.style.background = "#f3f4f6";
                        infoBox.style.borderLeft = "3px solid #1a73e8";
                        infoBox.style.borderRadius = "4px";
                        infoBox.style.fontSize = "11px";
                        infoBox.style.color = "#374151";
                        infoBox.style.lineHeight = "1.5";

                        const dataLabels = cols.slice(1)
                            .filter(col => !col.role || col.role === 'style')
                            .map(col => col.label || col.type)
                            .join(", ");

                        infoBox.innerHTML = '<strong>Data shown:</strong> ' + (dataLabels || 'Chart data');
                        card.appendChild(infoBox);
                    }

                    wrap.appendChild(card);

                    const chartType = c.chartType || "LineChart";
                    const ChartCtor = google.visualization[chartType];
                    if (!ChartCtor) {
                        console.warn("Unknown chartType:", chartType);
                        return;
                    }

                    const dt = buildDataTableWithOptionalTooltip(c);

                    const baseOpts = defaultChartOptionsFor(chartType);
                    const merged = mergeOptions(baseOpts, c.options || {});
                    if (merged && merged.tooltip) merged.tooltip.isHtml = true;
                    merged.focusTarget = merged.focusTarget || "category";

                    const tableW = fitCardToTable(card, wrap);
                    if (tableW) merged.width = tableW;
                    merged.height = finalH;

                    const rows = Array.isArray(c.rows) ? c.rows : [];
                    const firstType = (cols[0] && cols[0].type) ? cols[0].type : "string";

                    if ((firstType === "date" || firstType === "datetime") && rows.length > 10) {
                        const maxTicks = 8;
                        const step = Math.max(1, Math.ceil(rows.length / maxTicks));
                        const ticks = [];

                        for (let i = 0; i < rows.length; i += step) {
                            const x = rows[i] && rows[i][0];
                            const d = x instanceof Date ? x : (x ? new Date(x) : null);
                            if (d && !isNaN(d.getTime())) ticks.push(d);
                        }

                        const lastX = rows[rows.length - 1] && rows[rows.length - 1][0];
                        const lastD = lastX instanceof Date ? lastX : (lastX ? new Date(lastX) : null);
                        if (lastD && !isNaN(lastD.getTime())) {
                            if (!ticks.length || ticks[ticks.length - 1].getTime() !== lastD.getTime()) ticks.push(lastD);
                        }

                        merged.hAxis = merged.hAxis || {};
                        merged.hAxis.ticks = ticks;
                        merged.hAxis.format = merged.hAxis.format || "MMM d";
                        merged.hAxis.slantedText = true;
                        merged.hAxis.slantedTextAngle = merged.hAxis.slantedTextAngle || 45;
                    }

                    const chart = new ChartCtor(chartDiv);

                    google.visualization.events.addListener(chart, 'ready', function () {
                        try {
                            const uri = chart.getImageURI();
                            if (uri) {
                                lastChartImages.push({
                                    title: titleText,
                                    dataUri: uri,
                                    width: 1200,
                                    height: 400
                                });
                            }

                            const b = document.getElementById("ai-download-pdf");
                            if (b) { b.disabled = false; b.style.opacity = "1"; }
                        } catch (e) {
                            console.warn("Chart image export not supported:", e);
                        }
                    });

                    chart.draw(dt, merged);
                });
            });
        }

        function clearCharts() {
            const wrap = document.getElementById("ai-charts-wrap");
            if (wrap) {
                wrap.innerHTML = "";
                wrap.style.display = "none";
            }
            lastCharts = [];
            lastChartImages = [];
            const btnPdf = document.getElementById("ai-download-pdf");
            if (btnPdf) { btnPdf.disabled = true; btnPdf.style.opacity = "0.6"; }
        }

        // ==========================================================
        // ✅ FIXED STICKY HEADER (CLONE)
        // ==========================================================

        // ==========================================================
        // ✅ FIXED STICKY HEADER (CLONE) — DROP-IN REPLACEMENTS
        // ==========================================================

        function removeStickyClone() {
            const old = document.getElementById("ai-sticky-head");
            if (old) old.remove();

            // also clear latest update pointer (safe)
            if (window.__aiStickyUpdate) window.__aiStickyUpdate = null;
        }

        // ✅ CSS-Based Sticky Header (No Cloning Required)
        function ensureStickyHeaderCSS() {
            if (!resultTable) return;

            const scrollContainer = resultTable.closest('.scroll-container');
            if (!scrollContainer) return;

            // Remove any old cloned headers if they exist (cleanup from old method)
            const oldClone = document.getElementById("ai-sticky-head");
            if (oldClone) oldClone.remove();

            // Apply sticky positioning to thead
            const thead = resultTable.querySelector("thead");
            if (thead) {
                thead.style.position = 'sticky';
                thead.style.top = '0';
                thead.style.zIndex = '100';
                thead.style.backgroundColor = window.getComputedStyle(thead).backgroundColor || '#f8f9fa';
                thead.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.08)';
            }

            // Apply sticky to each th
            const ths = resultTable.querySelectorAll("thead th");
            ths.forEach(th => {
                th.style.position = 'sticky';
                th.style.top = '0';
                th.style.zIndex = '101';
                th.style.whiteSpace = 'nowrap';
                th.style.overflow = 'hidden';
                th.style.textOverflow = 'ellipsis';
                th.style.backgroundColor = window.getComputedStyle(th).backgroundColor || '#f8f9fa';
            });

            // Ensure scroll container allows scrolling
            scrollContainer.style.overflowY = 'auto';
            scrollContainer.style.overflowX = 'auto';
            scrollContainer.style.position = 'relative';
            scrollContainer.style.contain = 'layout style paint';
        }

        // Old cloning function - kept for backwards compatibility but disabled
        function copyComputedStyle(srcEl, dstEl, props) {
            const cs = window.getComputedStyle(srcEl);
            for (let i = 0; i < props.length; i++) {
                const p = props[i];
                dstEl.style[p] = cs.getPropertyValue(p);
            }
        }

        function ensureStickyHeaderClone() {
            // ✅ DEPRECATED: Cloning method disabled in favor of CSS sticky positioning
            // This function is kept empty to prevent errors if called elsewhere
            return;
            // always overwrite the global update pointer so listeners call the latest closure
            window.__aiStickyUpdate = update;

            // ✅ bind listeners only once (but they call window.__aiStickyUpdate)
            if (!window.__aiStickyBound) {
                window.__aiStickyBound = true;

                // best: listen to drawer scroll (your scroll container)
                // guard so we don't bind multiple times even if drawerBody changes
                if (!drawerBody.__aiStickyScrollBound) {
                    drawerBody.__aiStickyScrollBound = true;
                    drawerBody.addEventListener("scroll", function () {
                        if (typeof window.__aiStickyUpdate === "function") window.__aiStickyUpdate();
                    }, { passive: true });
                }

                // fallback: capture scroll from anywhere
                document.addEventListener("scroll", function () {
                    if (typeof window.__aiStickyUpdate === "function") window.__aiStickyUpdate();
                }, true);

                window.addEventListener("resize", function () {
                    if (typeof window.__aiStickyUpdate === "function") window.__aiStickyUpdate();
                }, { passive: true });
            }

            // initial sync
            syncStylesWidthsPosition();
            update();
        }


        // 🔹 Fetch suggestions from API
        // ✅ loadSuggestions function disabled
        function loadSuggestions($suggestionsBox) {
            // API suggestions disabled - function no longer makes API calls
        }

        // -----------------------------------------------------------
        // ✅ In-flight request tracking so the user can cancel an
        //    in-progress search and so stale responses (from a request
        //    that the user has superseded with a newer one) never
        //    overwrite the latest results.
        // -----------------------------------------------------------
        var currentAjaxRequest = null;
        var requestSeq = 0;

        function abortCurrentRequest() {
            if (currentAjaxRequest) {
                try { currentAjaxRequest.abort(); } catch (e) { /* noop */ }
                currentAjaxRequest = null;
            }
        }

        function restoreDrawerAskButton() {
            if (!drawerAsk) return;
            if (drawerAsk.dataset.aiOrigHtml !== undefined) {
                drawerAsk.innerHTML = drawerAsk.dataset.aiOrigHtml;
                delete drawerAsk.dataset.aiOrigHtml;
            }
            drawerAsk.classList.remove("ai-button-with-loader");
            drawerAsk.dataset.aiMode = '';
            drawerAsk.disabled = false;
        }

        function drawerAskHandler() {
            // ✅ If the button is currently in "Stop" mode, this click is a
            //    cancel request — abort the in-flight call and reset UI.
            if (drawerAsk && drawerAsk.dataset.aiMode === 'stop') {
                requestSeq++;                 // invalidate the in-flight response
                abortCurrentRequest();
                hideDrawerLoader();
                restoreDrawerAskButton();
                updateDrawerInputState();
                return;
            }

            var prompt = drawerInput ? drawerInput.value : "";
            if (!prompt || !prompt.trim()) return;
            prompt = prompt.trim();

            // ✅ Supersede any in-flight request so its response can't
            //    overwrite the result of this newer one.
            requestSeq++;
            var mySeq = requestSeq;
            abortCurrentRequest();

            // ✅ Display source type for new prompt search
            displayDrawerSourceInfo('newSearch', prompt);

            // ✅ Show loader while searching
            showDrawerLoader();

            // -----------------------------
            // ✅ Button: Spinner + Stop (stays clickable so the user
            //    can cancel an in-progress search at any time).
            // -----------------------------
            if (drawerAsk.dataset.aiOrigHtml === undefined) {
                drawerAsk.dataset.aiOrigHtml = drawerAsk.innerHTML;
            }
            drawerAsk.classList.add("ai-button-with-loader");
            drawerAsk.innerHTML = '<span class="ai-loader-spinner"></span>Stop';
            drawerAsk.disabled = false;
            drawerAsk.dataset.aiMode = 'stop';

            const userIdElement = document.getElementById("userId");
            const userId = userIdElement ? userIdElement.value.trim() : null;

            var payload = {
                personId: userId,
                question: prompt,
                debug: true,
                // ✅ null on the very first turn — server mints a new id and returns it.
                conversationId: currentConversationId
            };

            currentAjaxRequest = $.ajax({
                url: `${baseUrl}/api/kera/ask`,
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(payload),

                success: function (response) {
                    // ✅ Ignore stale responses (user already issued a newer
                    //    request or pressed Stop).
                    if (mySeq !== requestSeq) return;

                    // ✅ Persist the conversation id for the next /ask call so the
                    //    backend can interpret "yes" / "the first one" / "and last year".
                    if (response && response.conversationId) {
                        currentConversationId = response.conversationId;
                    }

                    var rows = [];
                    if (response && response.rows && response.rows.length) rows = response.rows;

                    appendTable(rows, null, response);
                    renderChartsFromResponse(response);

                    // ✅ Fetch latest search history ID after search completes
                    fetchLatestSearchHistoryId(userId);
                },

                error: function (xhr, textStatus) {
                    // ✅ Silently ignore aborts (user-initiated cancel or
                    //    supersession) and any stale-response errors.
                    if (textStatus === 'abort') return;
                    if (mySeq !== requestSeq) return;

                    var msg = "Something went wrong while processing your request.";
                    if (xhr && xhr.responseText) msg = xhr.responseText;
                    clearCharts();
                    appendTable(null, msg, null);
                },

                complete: function () {
                    // ✅ Only the latest request owns the button/loader UI.
                    if (mySeq !== requestSeq) return;

                    currentAjaxRequest = null;
                    hideDrawerLoader();
                    restoreDrawerAskButton();
                    updateDrawerInputState();
                }
            });
        }


        function detectJsonColumns(row) {
            var jsonCols = [];
            for (var key in row) {
                var val = row[key];
                if (!val) continue;

                if (typeof val === "object") {
                    jsonCols.push(key);
                    continue;
                }

                if (typeof val === "string") {
                    try {
                        var parsed = JSON.parse(val);
                        if (typeof parsed === "object") jsonCols.push(key);
                    } catch (e) { }
                }
            }
            return jsonCols;
        }

        if (typeof window.rowDataCache === "undefined") window.rowDataCache = {};
        if (typeof window.rowDataKeyCache === "undefined") window.rowDataKeyCache = {};
        if (typeof window.rowDataMetaCache === "undefined") window.rowDataMetaCache = {};
        if (typeof window.rowIndexCounter === "undefined") window.rowIndexCounter = 0;

        // =========================
        // ✅ CSV + PDF DOWNLOADS
        // =========================

        function ensureDownloadBar() {
            if (!resultTable || !resultTable.parentNode) return null;

            let bar = document.getElementById("ai-download-bar");
            if (bar) return bar;

            bar = document.createElement("div");
            bar.id = "ai-download-bar";
            bar.style.display = "none";
            bar.style.alignItems = "center";
            bar.style.gap = "10px";
            bar.style.margin = "10px 0";
            bar.style.padding = "10px 12px";
            bar.style.border = "1px solid #e5e7eb";
            bar.style.borderRadius = "10px";
            bar.style.background = "#fff";
            bar.style.boxShadow = "0 2px 10px rgba(0,0,0,0.04)";
            bar.style.fontFamily = "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif";

            const left = document.createElement("div");
            left.style.display = "flex";
            left.style.flex = "1";
            left.style.alignItems = "center";
            left.style.gap = "8px";

            const title = document.createElement("div");
            title.id = "ai-download-title";
            title.style.fontWeight = "700";
            title.style.fontSize = "13px";
            title.style.color = "#111827";
            title.innerText = "Export";

            const meta = document.createElement("div");
            meta.id = "ai-download-meta";
            meta.style.fontSize = "12px";
            meta.style.color = "#6b7280";
            meta.innerText = "";

            left.appendChild(title);
            left.appendChild(meta);

            // ✅ Dropdown wrapper for Download options
            const downloadDropdown = document.createElement("div");
            downloadDropdown.style.position = "relative";
            downloadDropdown.style.display = "inline-block";

            const btnDownload = document.createElement("button");
            btnDownload.type = "button";
            btnDownload.id = "ai-download-menu-toggle";
            btnDownload.innerText = "Download ▼";
            styleExportButton(btnDownload);

            const menu = document.createElement("div");
            menu.id = "ai-download-menu";
            menu.style.display = "none";
            menu.style.position = "absolute";
            menu.style.top = "100%";
            menu.style.right = "0";
            menu.style.marginTop = "5px";
            menu.style.backgroundColor = "#fff";
            menu.style.border = "1px solid #d1d5db";
            menu.style.borderRadius = "8px";
            menu.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
            menu.style.minWidth = "180px";
            menu.style.zIndex = "10000";

            // CSV menu item
            const itemCsv = document.createElement("button");
            itemCsv.type = "button";
            itemCsv.id = "ai-download-csv";
            itemCsv.innerText = "📊 Download CSV";
            styleDropdownMenuItem(itemCsv);

            // PDF menu item
            const itemPdf = document.createElement("button");
            itemPdf.type = "button";
            itemPdf.id = "ai-download-pdf";
            itemPdf.innerText = "📄 Download PDF";
            styleDropdownMenuItem(itemPdf);

            menu.appendChild(itemCsv);
            menu.appendChild(itemPdf);
            downloadDropdown.appendChild(btnDownload);
            downloadDropdown.appendChild(menu);

            bar.appendChild(left);
            bar.appendChild(downloadDropdown);

            resultTable.parentNode.insertBefore(bar, resultTable);

            // Toggle menu on click
            btnDownload.addEventListener("click", function (e) {
                e.stopPropagation();
                const isVisible = menu.style.display !== "none";
                menu.style.display = isVisible ? "none" : "flex";
                menu.style.flexDirection = "column";
            });

            // Close menu when clicking outside
            document.addEventListener("click", function (e) {
                if (!downloadDropdown.contains(e.target)) {
                    menu.style.display = "none";
                }
            });

            itemCsv.addEventListener("click", function () {
                if (!lastRows || !lastRows.length) return;
                downloadCSV(lastRows, "kera-results.csv");
                menu.style.display = "none";
            });

            itemPdf.addEventListener("click", function () {
                if (!lastRows || !lastRows.length) return;
                // ✅ If we have a search history ID, generate report from backend
                if (lastSearchHistoryId) {
                    // ✅ Show spinner while downloading
                    const originalText = itemPdf.innerText;
                    itemPdf.disabled = true;
                    itemPdf.innerHTML = '<span class="ai-loader-spinner"></span>Downloading...';

                    generateReportFromBackend(lastSearchHistoryId, function () {
                        // Callback to restore button state after download completes
                        itemPdf.innerHTML = originalText;
                        itemPdf.disabled = false;
                    });
                } else {
                    // Fallback to client-side PDF generation
                    downloadPDF(lastRows, "kera-results.pdf", lastPayload);
                }
                menu.style.display = "none";
            });

            return bar;
        }

        function styleExportButton(btn) {
            const theme = getHeaderTheme();

            btn.style.border = "1px solid " + (theme && theme.border ? theme.border : "#54834D");
            btn.style.background = "#54834D";
            btn.style.padding = "8px 10px";
            btn.style.borderRadius = "10px";
            btn.style.cursor = "pointer";
            btn.style.fontSize = "12px";
            btn.style.fontWeight = "700";
            btn.style.color = "#ffffff";        // ✅ white text for contrast
            btn.style.boxShadow = "0 1px 6px rgba(0,0,0,0.03)";

            btn.addEventListener("mouseenter", function () {
                btn.style.filter = "brightness(0.9)";
            });

            btn.addEventListener("mouseleave", function () {
                btn.style.filter = "";
            });
        }

        function styleDropdownMenuItem(item) {
            item.style.display = "block";
            item.style.width = "100%";
            item.style.padding = "10px 15px";
            item.style.border = "none";
            item.style.backgroundColor = "#fff";
            item.style.color = "#374151";
            item.style.fontSize = "13px";
            item.style.fontWeight = "500";
            item.style.cursor = "pointer";
            item.style.textAlign = "left";
            item.style.transition = "background-color 0.2s ease";

            item.addEventListener("mouseenter", function () {
                item.style.backgroundColor = "#f3f4f6";
            });

            item.addEventListener("mouseleave", function () {
                item.style.backgroundColor = "#fff";
            });
        }

        function showDownloadBar(rowCount) {
            const bar = ensureDownloadBar();
            if (!bar) return;
            const meta = document.getElementById("ai-download-meta");
            if (meta) meta.innerText = rowCount ? ("• " + rowCount + " row(s)") : "";
            bar.style.display = rowCount ? "flex" : "none";
        }

        function escapeCsvValue(v) {
            if (v === null || v === undefined) return "";
            let s = String(v);
            s = s.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
            if (/[",\n]/.test(s)) s = '"' + s.replace(/"/g, '""') + '"';
            return s;
        }

        function downloadCSV(rows, filename) {
            try {
                const cols = Object.keys(rows[0] || {});
                const lines = [];

                lines.push(cols.map(escapeCsvValue).join(","));

                for (let i = 0; i < rows.length; i++) {
                    const r = rows[i];
                    const line = cols.map(function (c) {
                        return escapeCsvValue(formatExportCellValue(r[c]));
                    }).join(",");
                    lines.push(line);
                }

                const csv = "\uFEFF" + lines.join("\n");
                const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
                const url = URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;
                a.download = filename || "results.csv";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
            } catch (e) {
                console.error("CSV download failed", e);
                alert("CSV download failed.");
            }
        }

        function downloadCSS(rows, filename) {
            try {
                const cols = Object.keys(rows[0] || {});
                let css = "/* AI Search Results - Table Styles */\n\n";
                css += "table {\n  border-collapse: collapse;\n  width: 100%;\n  font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n";
                css += "th {\n  background-color: #54834D;\n  color: white;\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  border: 1px solid #255047;\n}\n\n";
                css += "td {\n  padding: 10px 12px;\n  border: 1px solid #e5e7eb;\n}\n\n";
                css += "tr:nth-child(even) {\n  background-color: #f9fafb;\n}\n\n";
                css += "tr:hover {\n  background-color: #eff6ff;\n}\n\n";
                css += "/* Column-specific styles */\n";

                // Add column-specific styles
                cols.forEach(function (col, idx) {
                    css += "td:nth-child(" + (idx + 1) + ") {\n  max-width: 300px;\n  word-break: break-word;\n}\n";
                });

                css += "\n/* Responsive design */\n";
                css += "@media (max-width: 768px) {\n  table { font-size: 12px; }\n  th, td { padding: 8px; }\n}\n";

                const blob = new Blob([css], { type: "text/css;charset=utf-8" });
                const url = URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;
                a.download = filename || "results.css";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
            } catch (e) {
                console.error("CSS download failed", e);
                alert("CSS download failed.");
            }
        }

        // ======================================================
        // ✅ JSON → USER READABLE (questions array) for PDF export
        // ======================================================
        function tryParseJson(v) {
            if (v === null || v === undefined) return null;
            if (typeof v === "object") return v;
            if (typeof v !== "string") return null;
            const s = v.trim();
            if (!s) return null;
            if (!(s.startsWith("{") || s.startsWith("["))) return null;
            try { return JSON.parse(s); } catch (e) { return null; }
        }

        function normKey(k) {
            return String(k || "").toLowerCase().replace(/[^a-z0-9]/g, "");
        }

        function pickAny(obj, keys) {
            if (!obj || typeof obj !== "object") return null;
            const map = {};
            Object.keys(obj).forEach(k => map[normKey(k)] = k);
            for (let i = 0; i < keys.length; i++) {
                const real = map[normKey(keys[i])];
                if (real !== undefined) {
                    const v = obj[real];
                    if (v !== undefined && v !== null && String(v).trim() !== "") return v;
                }
            }
            return null;
        }

        function isQuestionsArray(arr) {
            if (!Array.isArray(arr) || !arr.length) return false;
            const o = arr[0];
            if (!o || typeof o !== "object") return false;
            // common markers
            return (
                pickAny(o, ["question", "question_text", "questionText", "label", "title"]) !== null ||
                pickAny(o, ["answer", "value", "response", "selected", "text"]) !== null
            );
        }

        function isFieldsArray(arr) {
            if (!Array.isArray(arr) || !arr.length) return false;
            const o = arr[0];
            if (!o || typeof o !== "object") return false;
            return (
                pickAny(o, ["label", "field", "fieldName", "name", "title"]) !== null &&
                pickAny(o, ["answer", "value", "response", "text"]) !== null
            );
        }

        function formatAnswerValue(v) {
            if (v === null || v === undefined) return "";
            if (typeof v === "boolean") return v ? "Yes" : "No";
            if (typeof v === "number") return String(v);
            if (typeof v === "string") return v.trim();

            if (Array.isArray(v)) {
                // if array of primitives -> join
                const allPrim = v.every(x => x === null || x === undefined || ["string", "number", "boolean"].includes(typeof x));
                if (allPrim) return v.map(x => formatAnswerValue(x)).filter(Boolean).join(", ");
                // else fallback
                try { return JSON.stringify(v); } catch (e) { return String(v); }
            }

            // object
            // common shapes like {text:"abc"} or {value:"abc"} etc
            const t = pickAny(v, ["text", "value", "answer", "label", "name", "title"]);
            if (t !== null) return String(t);
            try { return JSON.stringify(v); } catch (e) { return String(v); }
        }

        function beautifyQuestionsArray(arr) {
            // returns multi-line readable string
            const lines = [];
            for (let i = 0; i < arr.length; i++) {
                const q = arr[i] || {};

                const qText =
                    pickAny(q, ["question", "question_text", "questionText", "label", "title", "name"]) ||
                    ("Question " + (i + 1));

                // answer candidates (covers most checklist response formats)
                let ans =
                    pickAny(q, ["answer", "value", "response", "selected", "text", "result", "status"]);

                // sometimes answer is nested
                if (ans && typeof ans === "object") {
                    const nested = pickAny(ans, ["answer", "value", "text", "label", "name", "title"]);
                    if (nested !== null) ans = nested;
                }

                // extras
                const time = pickAny(q, ["time", "timestamp", "answered_at", "answeredAt", "created_at"]);
                const nfc = pickAny(q, ["nfc", "nfc_status", "nfcStatus", "nfc_validated", "nfcValidated"]);
                const note = pickAny(q, ["comment", "comments", "note", "notes", "remark", "remarks"]);
                const deficiency = pickAny(q, ["deficiency", "deficiency_text", "deficiencyText"]);
                const pics = pickAny(q, ["pictures", "images", "photos", "media", "attachments"]);

                const line1 = "• " + String(qText).trim();
                lines.push(line1);

                const aStr = formatAnswerValue(ans);
                if (aStr) lines.push("  - Answer: " + aStr);

                if (deficiency) lines.push("  - Deficiency: " + formatAnswerValue(deficiency));
                if (note) lines.push("  - Notes: " + formatAnswerValue(note));

                if (nfc !== null) lines.push("  - NFC: " + formatAnswerValue(nfc));
                if (time) lines.push("  - Time: " + formatAnswerValue(time));

                if (pics) {
                    if (Array.isArray(pics)) {
                        lines.push("  - Pictures: " + pics.length);
                    } else {
                        lines.push("  - Pictures: " + formatAnswerValue(pics));
                    }
                }

                lines.push(""); // blank line between questions
            }

            // trim trailing blank
            while (lines.length && lines[lines.length - 1] === "") lines.pop();
            return lines.join("\n");
        }

        function beautifyFieldsArray(arr) {
            const lines = [];
            for (let i = 0; i < arr.length; i++) {
                const field = arr[i] || {};
                const label =
                    pickAny(field, ["label", "field", "fieldName", "name", "title"]) ||
                    ("Field " + (i + 1));
                let answer = pickAny(field, ["answer", "value", "response", "text"]);
                const type = pickAny(field, ["type", "fieldType"]);

                lines.push("• " + String(label).trim());

                const answerText = formatAnswerValue(answer);
                lines.push("  - Answer: " + (answerText || "No input given"));
                if (type) {
                    lines.push("  - Type: " + formatAnswerValue(type));
                }
                lines.push("");
            }

            while (lines.length && lines[lines.length - 1] === "") lines.pop();
            return lines.join("\n");
        }

        function jsonToPdfText(val) {
            const parsed = tryParseJson(val);
            if (!parsed) return null;

            // array directly
            if (Array.isArray(parsed) && isQuestionsArray(parsed)) {
                return beautifyQuestionsArray(parsed);
            }
            if (Array.isArray(parsed) && isFieldsArray(parsed)) {
                return beautifyFieldsArray(parsed);
            }

            // object with questions
            if (parsed && typeof parsed === "object") {
                const q = pickAny(parsed, ["questions", "question", "items", "responses"]);
                if (Array.isArray(q) && isQuestionsArray(q)) {
                    return beautifyQuestionsArray(q);
                }

                const fields = pickAny(parsed, ["fields"]);
                if (Array.isArray(fields) && isFieldsArray(fields)) {
                    return beautifyFieldsArray(fields);
                }
            }

            // fallback: pretty JSON but not huge
            try {
                return JSON.stringify(parsed, null, 2);
            } catch (e) {
                return String(val);
            }
        }

        function formatExportCellValue(v) {
            if (v === null || v === undefined) {
                return "";
            }

            const formatted = jsonToPdfText(v);
            if (formatted) {
                return formatted;
            }

            if (typeof v === "object") {
                try {
                    return JSON.stringify(v);
                } catch (e) {
                    return String(v);
                }
            }

            return String(v);
        }

        function downloadPDF(rows, filename, payload) {
            if (!rows || !rows.length) return;

            const JsPDFCtor = (window.jspdf && window.jspdf.jsPDF) ? window.jspdf.jsPDF : window.jsPDF;
            if (!JsPDFCtor) {
                alert(
                    "PDF export requires jsPDF + autoTable.\n\n" +
                    "Please include:\n" +
                    "1) jspdf.umd.min.js\n" +
                    "2) jspdf.plugin.autotable.min.js"
                );
                return;
            }

            const doc = new JsPDFCtor({
                orientation: "landscape",
                unit: "pt",
                format: "a4"
            });

            const pageW = doc.internal.pageSize.getWidth();
            const pageH = doc.internal.pageSize.getHeight();
            const margin = { left: 40, right: 40, top: 40, bottom: 40 };
            let y = margin.top;

            doc.setFontSize(14);
            doc.text("Kera Results", margin.left, y);
            y += 18;

            doc.setFontSize(10);
            doc.text("Rows: " + rows.length + "  •  Generated: " + (new Date().toLocaleString()), margin.left, y);
            y += 16;

            // Charts first
            if (Array.isArray(lastChartImages) && lastChartImages.length) {
                lastChartImages.forEach(function (imgObj, idx) {
                    const title = imgObj.title || ("Chart " + (idx + 1));

                    if (y > pageH - 220) {
                        doc.addPage();
                        y = margin.top;
                    }

                    doc.setFontSize(11);
                    doc.text(title, margin.left, y);
                    y += 10;

                    const maxW = pageW - margin.left - margin.right;
                    const targetW = maxW;
                    const targetH = Math.round(targetW * (imgObj.height / imgObj.width));

                    if (y + targetH > pageH - margin.bottom) {
                        doc.addPage();
                        y = margin.top;
                        doc.setFontSize(11);
                        doc.text(title, margin.left, y);
                        y += 10;
                    }

                    try {
                        doc.addImage(imgObj.dataUri, "PNG", margin.left, y, targetW, targetH);
                        y += targetH + 16;
                    } catch (e) {
                        console.warn("Failed to embed chart image in PDF:", e);
                    }
                });
            }

            if (typeof doc.autoTable !== "function") {
                alert(
                    "jsPDF is loaded but autoTable plugin is missing.\n\n" +
                    "Please include jspdf.plugin.autotable.min.js"
                );
                return;
            }

            const cols = Object.keys(rows[0] || {});
            const head = [cols.map(c => String(c))];

            // ✅ Build body with properly formatted nested rows as tables
            const body = [];

            rows.forEach(function (r) {
                // Main row
                const mainRow = [];
                let detailsKey = null;
                let jsonColIndex = -1;
                let jsonColValue = null;

                function normKey(k) {
                    return String(k || "").toLowerCase().replace(/[^a-z0-9]/g, "");
                }

                for (let j = 0; j < cols.length; j++) {
                    const col = cols[j];
                    const v = r[col];

                    // Detect Details column (array)
                    if (Array.isArray(v) && normKey(col) === normKey("Details")) {
                        detailsKey = col;
                        mainRow.push("[View Items]");
                        continue;
                    }

                    // Detect JSON column (object)
                    if (typeof v === "object" && v !== null && !Array.isArray(v)) {
                        jsonColIndex = j;
                        jsonColValue = v;
                        mainRow.push(normKey(col) === normKey("Form Data") ? "[View Form Data]" : "[View Response]");
                        continue;
                    }

                    // Check for JSON string
                    if (typeof v === "string") {
                        try {
                            const parsed = JSON.parse(v);
                            if (typeof parsed === "object" && parsed !== null) {
                                jsonColIndex = j;
                                jsonColValue = parsed;
                                mainRow.push(normKey(col) === normKey("Form Data") ? "[View Form Data]" : "[View Response]");
                                continue;
                            }
                        } catch (e) { }
                    }

                    mainRow.push((v !== null && v !== undefined) ? String(v).substring(0, 100) : "");
                }

                body.push(mainRow);

                // ✅ Add nested table for Details array
                if (detailsKey && Array.isArray(r[detailsKey]) && r[detailsKey].length > 0) {
                    const detailsArr = r[detailsKey];

                    // Get all unique keys from all detail objects
                    const allKeys = {};
                    detailsArr.forEach(function (detail) {
                        for (let key in detail) {
                            if (detail.hasOwnProperty(key)) {
                                allKeys[key] = true;
                            }
                        }
                    });
                    const detailCols = Object.keys(allKeys);

                    // Add header row for nested table
                    const detailHeaderRow = [];
                    for (let j = 0; j < cols.length; j++) {
                        if (j === 0) {
                            detailHeaderRow.push("  " + detailCols.join(" | "));
                        } else {
                            detailHeaderRow.push("");
                        }
                    }
                    body.push(detailHeaderRow);

                    // Add data rows for each detail
                    detailsArr.forEach(function (detail, idx) {
                        const nestedRow = [];
                        for (let j = 0; j < cols.length; j++) {
                            if (j === 0) {
                                const values = detailCols.map(function (k) {
                                    const v = detail[k] || "";
                                    return String(v).substring(0, 30);
                                }).join(" | ");
                                nestedRow.push("  " + values);
                            } else {
                                nestedRow.push("");
                            }
                        }
                        body.push(nestedRow);
                    });
                }

                // ✅ Add nested rows for JSON Response / Form Data
                if (jsonColIndex >= 0 && jsonColValue !== null) {
                    const formatted = jsonToPdfText(jsonColValue);
                    if (formatted) {
                        formatted.split("\n").forEach(function (line) {
                            const nestedRow = [];
                            for (let j = 0; j < cols.length; j++) {
                                nestedRow.push(j === 0 ? "  " + line : "");
                            }
                            body.push(nestedRow);
                        });
                    } else {
                        let jsonData = jsonColValue;

                        // Extract questions array if it exists
                        let questionsArr = null;
                        if (Array.isArray(jsonData)) {
                            questionsArr = jsonData;
                        } else if (typeof jsonData === "object") {
                            for (let key in jsonData) {
                                if (jsonData.hasOwnProperty(key)) {
                                    const val = jsonData[key];
                                    if (Array.isArray(val) && val.length > 0) {
                                        questionsArr = val;
                                        break;
                                    }
                                }
                            }
                        }

                        if (questionsArr && Array.isArray(questionsArr) && questionsArr.length > 0) {
                            const allQKeys = {};
                            questionsArr.forEach(function (q) {
                                if (typeof q === "object" && q !== null) {
                                    for (let key in q) {
                                        if (q.hasOwnProperty(key)) {
                                            allQKeys[key] = true;
                                        }
                                    }
                                }
                            });
                            const qCols = Object.keys(allQKeys);

                            const qHeaderRow = [];
                            for (let j = 0; j < cols.length; j++) {
                                qHeaderRow.push(j === 0 ? "  " + qCols.join(" | ") : "");
                            }
                            body.push(qHeaderRow);

                            questionsArr.forEach(function (q) {
                                if (typeof q === "object" && q !== null) {
                                    const nestedRow = [];
                                    for (let j = 0; j < cols.length; j++) {
                                        if (j === 0) {
                                            const values = qCols.map(function (k) {
                                                const v = q[k] || "";
                                                return String(v).substring(0, 30);
                                            }).join(" | ");
                                            nestedRow.push("  " + values);
                                        } else {
                                            nestedRow.push("");
                                        }
                                    }
                                    body.push(nestedRow);
                                }
                            });
                        }
                    }
                }
            });

            // ✅ Header colors same as table header
            const theme = getHeaderTheme();
            const headStyles = {
                fontSize: 8,
                textColor: (theme && theme.fg) ? theme.fg : 255
            };

            // jsPDF-AutoTable expects RGB array for fillColor sometimes; if string, some versions accept it,
            // but safest is to keep default if parsing fails.
            function parseRgb(cssColor) {
                if (!cssColor) return null;
                const m = cssColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
                if (!m) return null;
                return [parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10)];
            }
            const rgb = theme ? parseRgb(theme.bg) : null;
            if (rgb) headStyles.fillColor = rgb;

            doc.autoTable({
                head: head,
                body: body,
                startY: y,
                styles: { fontSize: 8, cellPadding: 4, overflow: "linebreak" },
                headStyles: headStyles,
                margin: { left: margin.left, right: margin.right }
            });

            doc.save(filename || "kera-results.pdf");
        }

        // ✅ Fetch latest search history ID from backend
        function fetchLatestSearchHistoryId(personId) {
            if (!personId) return;

            $.ajax({
                url: `${baseUrl}/api/kera/report/latest-id`,
                type: "GET",
                dataType: "json",
                data: { personId: personId },
                success: function (response) {
                    if (response && response.id) {
                        lastSearchHistoryId = response.id;
                        console.log("✅ Latest search history ID set:", lastSearchHistoryId);
                    }
                },
                error: function (xhr) {
                    console.warn("Failed to fetch latest search history ID:", xhr);
                }
            });
        }

        // ✅ Generate PDF report from backend using search history ID
        function generateReportFromBackend(historyId, callback) {
            if (!historyId) {
                alert("No search history ID available. Please try searching again.");
                if (callback) callback();
                return;
            }

            const userIdElement = document.getElementById("userId");
            const personId = userIdElement ? userIdElement.value.trim() : null;

            if (!personId) {
                alert("User ID not found. Cannot generate report.");
                if (callback) callback();
                return;
            }

            // ✅ Call backend API to generate and download PDF
            const reportUrl = `${baseUrl}/api/kera/report?id=${encodeURIComponent(historyId)}&personId=${encodeURIComponent(personId)}`;

            // ✅ Use fetch to get blob and trigger download (prevents opening in browser)
            fetch(reportUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.blob();
                })
                .then(blob => {
                    // Create blob URL and download as file
                    const blobUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = `kera-report-${historyId}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    // Cleanup
                    window.URL.revokeObjectURL(blobUrl);

                    // ✅ Call callback to restore button state
                    if (callback) callback();
                })
                .catch(error => {
                    console.error("Error downloading report:", error);
                    alert("Failed to download report. Please try again.");
                    // ✅ Call callback even on error to restore button state
                    if (callback) callback();
                });
        }



        function destroyDataTableIfAny() {
            try {
                if (window.jQuery && $.fn && $.fn.DataTable) {
                    if ($.fn.DataTable.isDataTable("#resultTable")) {
                        $("#resultTable").DataTable().destroy(true); // true = remove DT wrappers
                    }
                }
            } catch (e) { /* ignore */ }
        }

        function appendTable(dataRows, showMessage, payload) {

            destroyDataTableIfAny();

            if (!resultTable) {
                console.error("resultTable is missing");
                return;
            }

            lastRows = Array.isArray(dataRows) ? dataRows : [];
            lastPayload = payload || null;

            resultTable.innerHTML = "";

            const oldDebug = document.getElementById("ai-debug-box");
            if (oldDebug) oldDebug.remove();

            showDownloadBar(0);

            // -------------------------
            // Helpers (key-robust read)
            // -------------------------
            function normKeyLocal(k) {
                return String(k || "")
                    .toLowerCase()
                    .replace(/[^a-z0-9]/g, "");
            }

            function makeLookup(row) {
                const map = {};
                if (!row) return map;
                Object.keys(row).forEach(function (k) {
                    map[normKeyLocal(k)] = k;
                });
                return map;
            }

            function pick(row, lookup, candidates) {
                for (let i = 0; i < candidates.length; i++) {
                    const nk = normKeyLocal(candidates[i]);
                    const real = lookup[nk];
                    if (real !== undefined) {
                        const v = row[real];
                        if (v !== undefined && v !== null && String(v).trim() !== "") return v;
                    }
                }
                return null;
            }

            // ✅ dataset detection (string because plan.dataset is enum name in JSON)
            function isChecklistItemsSummary(pl) {
                try {
                    return pl && pl.plan && pl.plan.dataset === "CHECKLIST_ITEMS";
                } catch (e) { return false; }
            }

            function isFormResponsesDataset(pl) {
                try {
                    return pl && pl.plan && pl.plan.dataset === "FORM_RESPONSES";
                } catch (e) { return false; }
            }

            // ✅ detect nested details array
            function isDetailsArray(v) {
                return Array.isArray(v) && v.length >= 0; // allow empty array too
            }

            // ✅ build nested table from detail rows
            function buildNestedTable(detailsRows) {
                const wrap = document.createElement("div");
                wrap.style.width = "100%";
                wrap.style.overflowX = "auto";

                // Empty state
                if (!Array.isArray(detailsRows) || !detailsRows.length) {
                    const empty = document.createElement("div");
                    empty.innerText = "No detail rows.";
                    empty.style.padding = "10px";
                    empty.style.color = "var(--muted)";
                    wrap.appendChild(empty);
                    return wrap;
                }

                const t = document.createElement("table");
                t.style.width = "100%";
                t.style.borderCollapse = "collapse";
                t.style.margin = "6px 0";
                t.style.fontSize = "12px";
                t.style.background = "#fff";
                t.style.border = "1px solid #e5e7eb";
                t.style.borderRadius = "10px";
                t.style.overflow = "hidden";

                const cols = Object.keys(detailsRows[0] || {});
                const thead = document.createElement("thead");
                const trh = document.createElement("tr");

                cols.forEach(function (c) {
                    const th = document.createElement("th");
                    th.innerText = c;
                    th.style.textAlign = "left";
                    th.style.padding = "8px 10px";
                    th.style.borderBottom = "1px solid #e5e7eb";
                    th.style.background = "#f9fafb";
                    th.style.whiteSpace = "nowrap";
                    trh.appendChild(th);
                });

                thead.appendChild(trh);

                const tbody = document.createElement("tbody");
                detailsRows.forEach(function (r) {
                    const tr = document.createElement("tr");
                    cols.forEach(function (c) {
                        const td = document.createElement("td");
                        td.style.padding = "8px 10px";
                        td.style.borderBottom = "1px solid #f3f4f6";
                        td.style.whiteSpace = "pre-wrap";
                        const v = r[c];
                        td.innerText = (v === null || v === undefined) ? "" : String(v);
                        tr.appendChild(td);
                    });
                    tbody.appendChild(tr);
                });

                t.appendChild(thead);
                t.appendChild(tbody);
                wrap.appendChild(t);

                return wrap;
            }

            // -------------------------
            // Message / empty states
            // -------------------------
            if (showMessage) {
                const thead = document.createElement("thead");
                const tbody = document.createElement("tbody");

                const tr = document.createElement("tr");
                const td = document.createElement("td");

                td.innerText = showMessage;
                td.colSpan = 1;
                td.style.whiteSpace = "pre-wrap";
                td.style.fontFamily = "sans-serif";
                td.style.fontWeight = "bold";
                td.style.color = "darkred";
                td.style.backgroundColor = "#fce4e4";
                td.style.padding = "20px";

                tr.appendChild(td);
                tbody.appendChild(tr);

                resultTable.appendChild(thead);
                resultTable.appendChild(tbody);
                resultTable.style.display = "table";

                removeStickyClone();
                clearCharts();
                return;
            }

            if (!Array.isArray(dataRows)) dataRows = [];

            if (!dataRows.length) {
                const thead = document.createElement("thead");
                const tbody = document.createElement("tbody");

                const tr2 = document.createElement("tr");
                const td2 = document.createElement("td");

                // ✅ Prefer the LLM-generated explanation from the backend
                //    ("No incidents found at 'Itopia' in the last 6 months — did you mean…?")
                //    over the generic message.
                var emptyMsg = (payload && payload.summary && String(payload.summary).trim())
                    ? String(payload.summary).trim()
                    : "No results found for your query.";
                td2.innerText = emptyMsg;
                td2.colSpan = 1;
                td2.style.textAlign = "center";
                td2.style.padding = "12px";
                td2.style.color = "var(--muted)";
                td2.style.whiteSpace = "pre-wrap";
                tr2.appendChild(td2);
                tbody.appendChild(tr2);

                // ✅ Render "Did you mean…?" suggestion chips. Clicking a chip
                //    sends the suggestion's rewriteAs as the next user question,
                //    inheriting the active conversationId.
                var suggestions = (payload && Array.isArray(payload.suggestions)) ? payload.suggestions : [];
                if (suggestions.length) {
                    var trChips = document.createElement("tr");
                    var tdChips = document.createElement("td");
                    tdChips.colSpan = 1;
                    tdChips.style.padding = "10px 12px 14px";
                    tdChips.style.textAlign = "center";

                    var label = document.createElement("div");
                    label.innerText = "Did you mean…?";
                    label.style.fontSize = "12px";
                    label.style.color = "#6b7280";
                    label.style.marginBottom = "8px";
                    tdChips.appendChild(label);

                    var chipsWrap = document.createElement("div");
                    chipsWrap.style.display = "flex";
                    chipsWrap.style.flexWrap = "wrap";
                    chipsWrap.style.gap = "6px";
                    chipsWrap.style.justifyContent = "center";

                    suggestions.forEach(function (s) {
                        if (!s || !s.rewriteAs) return;
                        var chip = document.createElement("button");
                        chip.type = "button";
                        chip.className = "ai-suggestion-chip";
                        chip.innerText = s.value || s.rewriteAs;
                        chip.title = s.rewriteAs;
                        chip.style.padding = "6px 12px";
                        chip.style.fontSize = "12px";
                        chip.style.border = "1px solid #d1d5db";
                        chip.style.borderRadius = "999px";
                        chip.style.background = "#fff";
                        chip.style.color = "#111827";
                        chip.style.cursor = "pointer";
                        chip.addEventListener("click", function () {
                            if (!drawerInput) return;
                            drawerInput.value = s.rewriteAs;
                            drawerAskHandler();
                        });
                        chipsWrap.appendChild(chip);
                    });

                    tdChips.appendChild(chipsWrap);
                    trChips.appendChild(tdChips);
                    tbody.appendChild(trChips);
                }

                resultTable.appendChild(thead);
                resultTable.appendChild(tbody);
                resultTable.style.display = "table";

                removeStickyClone();
                clearCharts();
                return;
            }

            showDownloadBar(dataRows.length);

            const isChecklist = isChecklistItemsSummary(payload);
            const isFormResponses = isFormResponsesDataset(payload);
            const jsonViewLabel = isFormResponses ? "View Form Data" : "View Response";

            // ✅ Detect JSON columns ONLY for non-checklist summary mode
            const jsonColumns = detectJsonColumns(dataRows[0]);

            // ======================================================
            // ✅ FILTER OUT "Gen Data Id" FROM VISIBLE COLUMNS
            // ======================================================
            const HIDDEN_COL_KEYS = [
                "gen_data_id",
                "gen data id",
                "Gen Data Id",
                "submission id",
                "Submission Id",
                "form id",
                "Form Id"
            ].map(normKeyLocal);

            // ✅ Also allow hiding raw "Details" column if you want, BUT we keep it visible as action text.
            const cols = Object.keys(dataRows[0]).filter(function (c) {
                return !HIDDEN_COL_KEYS.includes(normKeyLocal(c));
            });

            const thead = document.createElement("thead");
            const tbody = document.createElement("tbody");

            const headerTr = document.createElement("tr");
            for (let h = 0; h < cols.length; h++) {
                const th = document.createElement("th");
                th.innerText = cols[h];
                headerTr.appendChild(th);
            }
            thead.appendChild(headerTr);

            resultTable.appendChild(thead);
            resultTable.appendChild(tbody);

            // -------------------------
            // Rows
            // -------------------------
            for (let i = 0; i < dataRows.length; i++) {
                const row = dataRows[i] || {};
                const lookup = makeLookup(row);

                // ✅ CHECKLIST_ITEMS SUMMARY => inline expand on "Details"
                // We look for a "Details" field (case/space-insensitive)
                let detailsKey = null;
                for (let kk in row) {
                    if (normKeyLocal(kk) === normKeyLocal("Details")) { detailsKey = kk; break; }
                }
                const detailsVal = detailsKey ? row[detailsKey] : null;

                if (isChecklist && (detailsKey && isDetailsArray(detailsVal))) {
                    // Summary row
                    const trSum = document.createElement("tr");
                    trSum.classList.add("ai-summary-row");

                    for (let j = 0; j < cols.length; j++) {
                        const col = cols[j];
                        const td3 = document.createElement("td");

                        if (normKeyLocal(col) === normKeyLocal(detailsKey)) {
                            td3.innerText = "View Items";
                            td3.classList.add("sb-fw-bold-cblue");
                            td3.style.cursor = "pointer";
                            td3.style.textDecoration = "underline";
                        } else {
                            const cellValue = row[col];
                            td3.innerText =
                                (cellValue !== undefined && cellValue !== null)
                                    ? String(cellValue)
                                    : "";
                        }

                        trSum.appendChild(td3);
                    }

                    // Child row (expanded)
                    const trChild = document.createElement("tr");
                    trChild.classList.add("ai-detail-row");
                    trChild.style.display = "none";

                    const tdChild = document.createElement("td");
                    tdChild.colSpan = cols.length;
                    tdChild.style.padding = "10px 12px";
                    tdChild.style.background = "#fcfcfd";
                    tdChild.style.borderTop = "1px solid #e5e7eb";

                    tdChild.appendChild(buildNestedTable(detailsVal));
                    trChild.appendChild(tdChild);

                    // Toggle: click on "View Items" cell
                    const toggleIndex = cols.findIndex(function (c) { return normKeyLocal(c) === normKeyLocal(detailsKey); });
                    if (toggleIndex >= 0) {
                        const toggleCell = trSum.children[toggleIndex];
                        if (toggleCell) {
                            toggleCell.addEventListener("click", function () {
                                const isOpen = trChild.style.display !== "none";

                                if (isOpen) {
                                    trChild.style.setProperty("display", "none", "important");
                                    toggleCell.innerText = "View Items";
                                } else {
                                    trChild.style.setProperty("display", "table-row", "important");
                                    toggleCell.innerText = "Hide Items";
                                }
                            });
                        }
                    }

                    tbody.appendChild(trSum);
                    tbody.appendChild(trChild);
                    continue;
                }

                // ✅ DEFAULT MODE (your existing behavior)
                const tr3 = document.createElement("tr");

                let hasJson = false;

                for (let j = 0; j < cols.length; j++) {
                    const col = cols[j];
                    const td3 = document.createElement("td");
                    const cellValue = row[col];

                    if (jsonColumns.indexOf(col) !== -1) {
                        // ✅ create key for this row’s JSON
                        const key = "DYN_" + window.rowIndexCounter++;
                        window.rowDataCache[key] = cellValue;

                        // ✅ STILL READ Gen Data Id EVEN THOUGH IT IS HIDDEN
                        const genId = pick(row, lookup, [
                            "gen_data_id", "gen data id", "Gen Data Id",
                            "_row_id", "_rowid", "response_id", "ResponseID"
                        ]);

                        if (genId !== null && genId !== undefined && String(genId).trim() !== "") {
                            window.rowDataKeyCache[key] = String(genId).trim();
                        }

                        tr3.setAttribute("data-json", key);
                        tr3.setAttribute("data-row-id", key);
                        tr3.setAttribute("data-submitter", pick(row, lookup, [
                            "Guard Name", "guard_name", "Guard", "guard"
                        ]) || "");
                        tr3.setAttribute("data-checklist", pick(row, lookup, [
                            "Checklist Name", "checklist_name", "Form", "form"
                        ]) || "");
                        tr3.setAttribute("data-location", pick(row, lookup, [
                            "Location", "location", "location_name", "Location Name"
                        ]) || "");
                        tr3.setAttribute("data-date", pick(row, lookup, [
                            "Submitted At", "submitted_at", "submission_date"
                        ]) || "");
                        if (isFormResponses) {
                            tr3.setAttribute("data-view-type", "form");
                            const formId = pick(row, lookup, [
                                "Form Id", "form_id", "form id"
                            ]);
                            const submissionId = pick(row, lookup, [
                                "Submission Id", "submission_id", "submission id"
                            ]);
                            if (formId !== null && formId !== undefined && String(formId).trim() !== "") {
                                tr3.setAttribute("data-form-id", String(formId).trim());
                            }
                            if (submissionId !== null && submissionId !== undefined && String(submissionId).trim() !== "") {
                                tr3.setAttribute("data-submission-id", String(submissionId).trim());
                            }

                            window.rowDataMetaCache[key] = {
                                viewType: "form",
                                formId: (formId !== null && formId !== undefined) ? String(formId).trim() : "",
                                submissionId: (submissionId !== null && submissionId !== undefined) ? String(submissionId).trim() : "",
                                locationName: pick(row, lookup, [
                                    "Location", "location", "location_name", "Location Name"
                                ]) || "",
                                formName: pick(row, lookup, [
                                    "Checklist Name", "checklist_name", "Form", "form"
                                ]) || "",
                                submittedAt: pick(row, lookup, [
                                    "Submitted At", "submitted_at", "submission_date"
                                ]) || ""
                            };

                            if (cellValue && typeof cellValue === "object") {
                                const payloadFormId = cellValue.formId || cellValue.form_id;
                                const payloadSubmissionId = cellValue.submissionId || cellValue.submission_id;
                                if (payloadFormId) {
                                    window.rowDataMetaCache[key].formId = String(payloadFormId).trim();
                                }
                                if (payloadSubmissionId) {
                                    window.rowDataMetaCache[key].submissionId = String(payloadSubmissionId).trim();
                                }
                            }
                        } else {
                            window.rowDataMetaCache[key] = {
                                viewType: "checklist"
                            };
                        }

                        hasJson = true;

                        td3.innerText = jsonViewLabel;
                        td3.classList.add("sb-fw-bold-cblue");
                        td3.style.cursor = "pointer";
                        td3.style.textDecoration = "underline";
                    } else {
                        td3.innerText =
                            (cellValue !== undefined && cellValue !== null)
                                ? String(cellValue)
                                : "";
                    }

                    tr3.appendChild(td3);
                }

                if (hasJson) {
                    tr3.classList.add("response-details-updated-btn", "stool-shared-popup-btn");
                    tr3.setAttribute("data-id", "response-details");
                }

                tbody.appendChild(tr3);
            }

            resultTable.style.display = "table";
            ensureStickyHeaderCSS();
        }


        if (drawerAsk) drawerAsk.addEventListener('click', drawerAskHandler);

        function openDrawerWithQuery(text) {
            openDrawer();
            restoreDrawerSearchInput();
            if (drawerInput) drawerInput.value = text || '';
            updateDrawerInputState();
            setTimeout(() => drawerAskHandler(), 120);
        }

        // ===== Chart redraw scheduling (width sync to table) =====
        let __chartResizeTimer = null;
        function scheduleChartRedraw() {
            if (!lastPayload) return;
            clearTimeout(__chartResizeTimer);
            __chartResizeTimer = setTimeout(function () {
                renderChartsFromResponse(lastPayload);
            }, 140);
        }
        window.addEventListener("resize", scheduleChartRedraw);

        // ===== FIXED Drawer resizing =====
        (function () {
            if (!resizer || !drawer) return;
            let isResizing = false;
            const MIN_WIDTH = 300;

            resizer.addEventListener('mousedown', e => {
                e.preventDefault();
                isResizing = true;
                document.body.style.cursor = 'ew-resize';
            });

            document.addEventListener('mousemove', e => {
                if (!isResizing) return;
                let newWidth = window.innerWidth - e.clientX;
                newWidth = Math.max(MIN_WIDTH, newWidth);
                drawer.style.width = newWidth + 'px';
            });

            document.addEventListener('mouseup', () => {
                if (!isResizing) return;
                isResizing = false;
                document.body.style.cursor = '';
                scheduleChartRedraw();
            });

            window.addEventListener('resize', () => {
                const drawerRect = drawer.getBoundingClientRect();
                if (drawerRect.width < MIN_WIDTH) {
                    drawer.style.width = MIN_WIDTH + 'px';
                }
            });
        })();
        // ===== END Drawer resizing =====

        window.openDrawerWithQuery = openDrawerWithQuery;
        window.drawerAskHandler = drawerAskHandler;
    }

    $(window).ready(function () {
        init();
    });
})(jQuery);
